import React from "react";
import './Textbox.css'
import { Fonts } from "../../design/Font";
import u26 from '../../images/hsa-user_login/u26.png'

export default class Textbox extends React.Component{

    constructor(props){
        super(props);
        this.state={
            isFocused:false,
            secure:false,
        }
    }

    componentDidMount=()=>{
        this.setState({secure:this.props.password})
    }

    handleFocus = () => {
        this.setState({ isFocused: true });
    };
    
    handleBlur = () => {
        this.setState({ isFocused: false });
    };

    render() {
        const { title, value, onChange, errorMessage, required, password} = this.props;
        const { isFocused } = this.state;
        return (
            <div>
                <label style={{color:'#555', margin:"0.5%", fontFamily:'Helvetica', fontSize:12}}>
                    {title}
                    {required?<span style={{color:"#C00"}}>*</span>:null}
                </label>
                <div style={{display:'flex', flex:1, borderWidth:1,border:isFocused?"1px solid #3399CC":"1px solid #c5c5c5",borderRadius:"3px", padding:"2%", marginTop:"2.5%" ,height:"5vh", overflow:'hidden'}} >
                    <input
                    type={this.state.secure?"password":"text"}
                    style={{borderWidth:0, outline:'none',width:"95%", }}
                    value={value}
                    onChange={onChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    />
                    {password?<img alt="u26" onClick={()=>{this.setState({secure:!this.state.secure})}} style={{objectFit:'cover', height:"33%", alignSelf:'center'}} src={u26}/>:null}
                </div>
                <span style={{ ...Fonts.error, minHeight: "16px", display: "block" }}>
                    {errorMessage}
                </span>
            </div>
        );
    }
}